import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=72fc314e&scoped=true"
import script from "./Totals.vue?vue&type=script&lang=js"
export * from "./Totals.vue?vue&type=script&lang=js"
import style0 from "./Totals.vue?vue&type=style&index=0&id=72fc314e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fc314e",
  null
  
)

export default component.exports